import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { locationPathname as locationPathnameSelector } from 'ggApp/modules/router/selectors';

import LoggedOutControls from './LoggedOutControls';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            locationPathname: locationPathnameSelector,
        }),
    ),
    withProps(({ activeStore: { code } }) => ({
        storeCode: code,
    })),
);

export default enhance(LoggedOutControls);
